import { render, staticRenderFns } from "./ControlButtons.vue?vue&type=template&id=2c136d7b&scoped=true&"
import script from "./ControlButtons.vue?vue&type=script&lang=ts&"
export * from "./ControlButtons.vue?vue&type=script&lang=ts&"
import style0 from "./ControlButtons.vue?vue&type=style&index=0&id=2c136d7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c136d7b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/3ce44491/1/fsi-lab/soft/app/robot-config/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VFlex,VIcon,VLayout})
